<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  },
  render (h, context) {
    const { icon, title } = context.props
    const vnodes = []
    if (icon) {
      if (icon.includes('el-icon')) {
        vnodes.push(<i class={[icon, 'sub-el-icon']} />)
      } else {
        const iconFile = require(`@/icons/svg/${icon}.svg`)
        vnodes.push(<img src={iconFile} alt='' width={32} height={32} class="svg-white"/>)
        vnodes.push(<span>&nbsp;</span>)
        // vnodes.push(<svg-icon icon-class={icon}/>)
      }
    }
    if (title) {
      vnodes.push(<span slot='title'>{(title)}</span>)
    }
    return vnodes
  }
}
</script>

<style scoped>
.sub-el-icon {
  color: currentColor;
  width: 1em;
  height: 1em;
}

.svg-white {
  filter: invert(98%) sepia(6%) saturate(275%) hue-rotate(151deg) brightness(117%) contrast(100%);
}
</style>
